<template>
  <b-modal id="status" ref="modal" size="lg" title="Add" @show="resetModal" @hidden="resetModal"
           @ok="handleOk">
    <b-form @submit.stop.prevent="onSubmit" >
      <div class="row">
        <!-- grid column -->
        <div class="col-lg-12">
          <!-- .card -->
          <div class="card card-fluid">
            <!-- .card-body -->
            <div class="card-body">
              <div class="form-row">
                <label class="col-md-3">Company Name</label>
                <div class="col-md-8 mb-3">
                  <v-select :options="options.companies" v-model="input_data.company" :reduce="company =>company.code"></v-select>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Contract Classification</label>
                <div class="col-md-8 mb-3">
                  {{input_data.contract_classification}}
                  <v-select :options="options.contract_classifications" v-model="input_data.contract_classification" :reduce="contract =>contract.code"></v-select>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Employment Category</label>
                <div class="col-md-8 mb-3">
                  <v-select :options="options.employment_categories" v-model="input_data.employment_category"></v-select>
                </div>
              </div>

              <div class="form-row">
                <label class="col-md-3">Type of Contract</label>
                <div class="col-md-8 mb-3">
                  <v-select :options="options.type_contract" v-model="input_data.type_contract"></v-select>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Contract Status</label>
                <div class="col-md-8 mb-3">
                  <v-select :options="options.status_contract" v-model="input_data.status_contract"></v-select>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Job Title</label>
                <div class="col-md-8 mb-3">
                  <v-select :options="options.job_title" v-model="input_data.job_title"></v-select>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Duty Station</label>
                <div class="col-md-8 mb-3">
                  <v-select :options="options.duty_station" v-model="input_data.duty_station"></v-select>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Grade</label>
                <div class="col-md-8 mb-3">
                  <v-select :options="options.status_contract" v-model="input_data.status_contract"></v-select>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Date of Issue</label>
                <div class="col-md-8 mb-3">
                  <flat-pickr :config="config" v-model="input_data.issue_date"></flat-pickr>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Expiration Date</label>
                <div class="col-md-8 mb-3">
                  <flat-pickr :config="config" v-model="input_data.expiration_date"></flat-pickr>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-form>
  </b-modal>
</template>

<script>
import {BForm, BFormGroup, BFormInput, BButton, BModal} from "bootstrap-vue"

import flatPickr from 'vue-flatpickr-component'
import vSelect  from "vue-select"
export default {
  name: "EmployeeStatusInput",
  components:{
    BForm,
    BFormGroup,
    BFormInput,
    flatPickr,
    BButton,
    BModal,
    vSelect
  },
  data(){
    return {
      input_data:{
        company:"",
        contract_classification:"",
        employment_category:"",
        type_contract:"",
        status_contract:"",
        job_title:"",
        issue_date:"",
        expiration_date:""
      },
      options:{
        companies:[],
        contract_classifications:[],
        employment_categories:[],
        type_contract:[],
        status_contract:[],
        job_title:[]
      },
      config:{
        altFormat: 'M j, Y',
        altInput: true,
        dateFormat: 'Y-m-d',
        locale: {
          rangeSeparator: ' - '
        },
      },
    }
  },
  methods:{
    onSubmit(){

    },
    handleOk(){

    },
    resetModal(){
      this.items = []
    },
  }
}
</script>